export const useNewsPagination = () => {
  const { isDesktop } = useDevice()

  const countNews = ref(0) // Кол-=во новостей всего
  const currentPage = ref(1)
  const countElementsOnPage = !isDesktop ? 6 : 12 // Кл-во новостей на странице

  const countPages = computed(() => {
    return Math.ceil(countNews.value / countElementsOnPage)
  })

  const scrollToTop = () => {
    window?.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const onChangeCurrentPage = async (value: number, fetchMethod: Function) => {
    currentPage.value = value

    await fetchMethod()

    scrollToTop()
  }

  return {
    countNews,
    currentPage,
    countElementsOnPage,
    countPages,
    onChangeCurrentPage,
  }
}
